import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Client } from '@app/core/model/client.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VisitasService } from '../../../core/service/visitas.service';
import { ClientService } from '../../../core/service/client.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-crear-visitas',
  templateUrl: './crear-visitas.component.html',
  styleUrls: ['./crear-visitas.component.css']
})
export class CrearVisitasComponent implements OnInit {
  visitaForm: FormGroup;
  selectedValue: any;
  cliente: any;
  fecha: any;
  detalle: any;
  cliente_id: any;

  @Input() title: string;
  // @Input() cliente_id: string;
  @Input() estado: boolean;
  isLoading = false;
  todos: number;
  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private visitaService: VisitasService,
    private clienteService: ClientService
  ) {}

  ngOnInit() {
    this.listCliente();
    this.createFrom();
    this.cliente_id = 60;
  }

  listCliente() {
    this.clienteService.getAll().subscribe(data => {
      this.cliente = data.data;
      console.log('data cliente', this.cliente);
    });
  }

  createFrom() {
    console.log('dentro del create');
    this.visitaForm = this.formBuilder.group({
      fecha: ['', Validators.required],
      detalle: ['', Validators.required],
      cliente_id: ['']
    });
    console.log('form:', this.visitaForm.value);
  }
  // getSelectedCliente(event: Client) {
  //   // alert(event);

  //   console.log('Producto Changed: ' + event.cliente_id);
  //   // console.log(JSON.stringify(event));
  //   // this.resetPurchase();
  //   // this.showDiv = null;
  //   // console.log(i);
  //   this.todos = event.cliente_id;
  //   //  this.patchValues(event.producto_id, i);
  //   // this.addressCustomer = event.address;
  // }

  registerVisita(visitaForm: any) {
    console.log('form del register', visitaForm);

    this.visitaForm.value.cliente_id = this.cliente_id;

    if (this.estado === true) {
      this.visitaService
        .update(this.cliente_id, visitaForm)
        .pipe(
          finalize(() => {
            this.visitaForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data);
            this.visitaForm.reset();
            this.activeModal.close(data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    } else {
      this.isLoading = true;
      this.visitaService
        .create(visitaForm)
        .pipe(
          finalize(() => {
            this.visitaForm.markAsPristine();
            this.isLoading = false;
          })
        )
        .subscribe(
          data => {
            Swal.fire(data);
            // this.visitaForm.reset();
            this.activeModal.close(data);
            console.log('dataaaa', data);
          },
          error1 => {
            Swal.fire(error1.error);
          }
        );
    }
  }
}
